import { computed, unref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useSessionValues } from '@/composables/useSessionValues'
import apis from '@/services'

const getInvoicesList = async params => {
  const response = await apis.premium.getInvoices(params)
  return response?.data
}

/**
 * Fetches invoices with optional filters.
 * Automatically uses current token from global state. AccommodationIds are part of filters
 */
export function useInvoices({ accommodationIds, productTypes, paymentStatuses, startDate, endDate }) {
  const { hasAdminOrSupport, token } = useSessionValues()
  const { isLoading, isFetching, isSuccess, isError, data } = useQuery({
    queryKey: ['invoices', token, accommodationIds, productTypes, paymentStatuses, startDate, endDate],
    enabled: computed(() => unref(hasAdminOrSupport)),
    queryFn: ({ queryKey }) =>
      getInvoicesList({
        accommodationIds: queryKey[2],
        productTypes: queryKey[3],
        paymentStatuses: queryKey[4],
        startDate: queryKey[5],
        endDate: queryKey[6],
      }),
  })

  const invoicesList = computed(() => data?.value ?? [])

  return {
    isInvoicesListLoading: isLoading,
    isInvoicesListFetching: isFetching,
    isInvoicesListSuccess: isSuccess,
    isInvoicesListError: isError,
    invoicesList,
  }
}
